/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ApiError from '../model/ApiError';
import DetailResponse from '../model/DetailResponse';
import JobCreateResponse from '../model/JobCreateResponse';
import JobFileResponse from '../model/JobFileResponse';
import JobProofLinkResponse from '../model/JobProofLinkResponse';
import JobRequest from '../model/JobRequest';
import JobUpdateResponse from '../model/JobUpdateResponse';
import JobWithPosition from '../model/JobWithPosition';
import KanbanMoveResponse from '../model/KanbanMoveResponse';
import ModifyJobProofLinkRequest from '../model/ModifyJobProofLinkRequest';
import MoveJobRequest from '../model/MoveJobRequest';

/**
* Job service.
* @module api/JobApi
* @version V1
*/
export default class JobApi {

    /**
    * Constructs a new JobApi. 
    * @alias module:api/JobApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createJob operation.
     * @callback module:api/JobApi~createJobCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobCreateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/JobRequest} [jobRequest] 
     * @param {module:api/JobApi~createJobCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobCreateResponse}
     */
    createJob(opts, callback) {
      opts = opts || {};
      let postBody = opts['jobRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobCreateResponse;
      return this.apiClient.callApi(
        '/jobs', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteJob operation.
     * @callback module:api/JobApi~deleteJobCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobUpdateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId 
     * @param {module:api/JobApi~deleteJobCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobUpdateResponse}
     */
    deleteJob(jobId, callback) {
      let postBody = null;
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling deleteJob");
      }

      let pathParams = {
        'jobId': jobId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobUpdateResponse;
      return this.apiClient.callApi(
        '/jobs/{jobId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the duplicateJob operation.
     * @callback module:api/JobApi~duplicateJobCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobCreateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId 
     * @param {module:api/JobApi~duplicateJobCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobCreateResponse}
     */
    duplicateJob(jobId, callback) {
      let postBody = null;
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling duplicateJob");
      }

      let pathParams = {
        'jobId': jobId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobCreateResponse;
      return this.apiClient.callApi(
        '/jobs/duplicate/{jobId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getJobById operation.
     * @callback module:api/JobApi~getJobByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId 
     * @param {module:api/JobApi~getJobByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DetailResponse}
     */
    getJobById(jobId, callback) {
      let postBody = null;
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling getJobById");
      }

      let pathParams = {
        'jobId': jobId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = DetailResponse;
      return this.apiClient.callApi(
        '/jobs/{jobId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getJobs operation.
     * @callback module:api/JobApi~getJobsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/JobWithPosition>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {String} [q] 
     * @param {module:api/JobApi~getJobsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/JobWithPosition>}
     */
    getJobs(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'q': opts['q']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [JobWithPosition];
      return this.apiClient.callApi(
        '/jobs', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the moveJob operation.
     * @callback module:api/JobApi~moveJobCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KanbanMoveResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MoveJobRequest} [moveJobRequest] 
     * @param {module:api/JobApi~moveJobCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/KanbanMoveResponse}
     */
    moveJob(opts, callback) {
      opts = opts || {};
      let postBody = opts['moveJobRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = KanbanMoveResponse;
      return this.apiClient.callApi(
        '/jobs/position', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateAndDeleteProofJobLink operation.
     * @callback module:api/JobApi~updateAndDeleteProofJobLinkCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobProofLinkResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ModifyJobProofLinkRequest} [modifyJobProofLinkRequest] 
     * @param {module:api/JobApi~updateAndDeleteProofJobLinkCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobProofLinkResponse}
     */
    updateAndDeleteProofJobLink(opts, callback) {
      opts = opts || {};
      let postBody = opts['modifyJobProofLinkRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobProofLinkResponse;
      return this.apiClient.callApi(
        '/jobs/proofs', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateJob operation.
     * @callback module:api/JobApi~updateJobCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobRequest} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId 
     * @param {Object} opts Optional parameters
     * @param {module:model/JobRequest} [jobRequest] 
     * @param {module:api/JobApi~updateJobCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobRequest}
     */
    updateJob(jobId, opts, callback) {
      opts = opts || {};
      let postBody = opts['jobRequest'];
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling updateJob");
      }

      let pathParams = {
        'jobId': jobId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobRequest;
      return this.apiClient.callApi(
        '/jobs/{jobId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadJobFiles operation.
     * @callback module:api/JobApi~uploadJobFilesCallback
     * @param {String} error Error message, if any.
     * @param {Object.<String, module:model/{String: JobFileResponse}>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId 
     * @param {File} body Upload Binary
     * @param {module:api/JobApi~uploadJobFilesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object.<String, module:model/{String: JobFileResponse}>}
     */
    uploadJobFiles(jobId, body, callback) {
      let postBody = body;
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling uploadJobFiles");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling uploadJobFiles");
      }

      let pathParams = {
        'jobId': jobId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = {'String': JobFileResponse};
      return this.apiClient.callApi(
        '/jobs/{jobId}/files', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getJobFiles operation.
     * @callback module:api/JobApi~getJobFilesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/JobFileResponse>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId
     * @param {module:api/JobApi~getJobFilesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/JobFileResponse>}
     */
    getJobFiles(jobId, callback) {
      let postBody = null;
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling getJobFiles");
      }

      let pathParams = {
        'jobId': jobId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [JobFileResponse];
      return this.apiClient.callApi(
        '/jobs/{jobId}/files', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteJobFile operation.
     * @callback module:api/JobApi~deleteJobFileCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} jobId
     * @param {Number} fileId
     * @param {module:api/JobApi~deleteJobFileCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteJobFile(jobId, fileId, callback) {
      let postBody = null;
      // verify the required parameter 'jobId' is set
      if (jobId === undefined || jobId === null) {
        throw new Error("Missing the required parameter 'jobId' when calling deleteJobFile");
      }
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling deleteJobFile");
      }

      let pathParams = {
        'jobId': jobId,
        'fileId': fileId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/jobs/{jobId}/files/{fileId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
